module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Danny Sperry","slug":"blog/author/danny-sperry","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/danny-sperry"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-author-danny-sperry.json
// module id = 1335
// module chunks = 19853164899746